import styled from "styled-components";

export const MainDiv = styled.div`
    width: 100%;
    min-height:100vh;
    background-color: ${({ $isDivOverFiftyPercent }) => {
        if ($isDivOverFiftyPercent[0]) return "#444b53";
        if ($isDivOverFiftyPercent[1]) return "#646765";
        if ($isDivOverFiftyPercent[2]) return "#7c807d";
        if ($isDivOverFiftyPercent[3]) return "#959896";
        if ($isDivOverFiftyPercent[4]) return "#aeb0af";
        return "#444b53";
    }};
    transition: 0.8s;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px ;
    
`

export const RamkaDiv = styled.div`
  width: 100%;
  min-height: 100px;
  display: flex;
  flex-direction: ${({ $first }) => ($first ? "row" : "row-reverse")};
  align-items: center;
  justify-content: space-around;
  text-align: center;
  transition: 0.8s;
  padding-top: 80px;
  opacity: ${({ $isDivOverFiftyPercent }) =>
    $isDivOverFiftyPercent ? "1" : "0"};

  img {
    width: 30%;
    transition: 0.8s;
    border-radius: 20px;

    margin-right: ${({ $first }) => ($first ? "30px" : "0")};
    margin-left: ${({ $first }) => ($first ? "0" : "30px")};

    @media (max-width: 800px) {
      margin-top: 20px;
      margin-right: 0;
      margin-left: 0;
      width: 90%;
    }
  }

  span {
    transition: 0.8s;
    width: 40%;
    margin-left: ${({ $first }) => ($first ? "30px" : "0")};
    margin-right: ${({ $first }) => ($first ? "0" : "30px")};
    font-family: "Lato", sans-serif;
    font-size: 35px;
    font-weight: 300;
    color: white;

    @media (max-width: 988px) {
      font-size: 25px;
    }
    @media (max-width: 800px) {
      font-size: 25px;
      margin-left: 0;
      margin-right: 0;
      width: 90%;
    }

    p {
      font-size: 18px;
      margin-top: 20px;
      font-weight: 250;
      line-height: 25px;
    }
  }

  @media (max-width: 800px) {
    flex-direction: column;
    justify-content: center;
  }
`;
